<div class="flex flex-col w-full p-6 sm:p-8">
  
  <!-- Header -->
  <div class="flex items-center justify-between mb-6">
    <div>
      <h1 class="text-3xl font-bold tracking-tight">Monitoring KSeF</h1>
      <p class="text-secondary mt-1">Wysyłki batch, błędy, synchronizacja i logi</p>
    </div>
  </div>

  <!-- Content with Vertical Navigation -->
  <div class="bg-card rounded-2xl shadow-lg overflow-hidden">
    <div class="flex flex-col md:flex-row">
      
      <!-- Vertical Navigation -->
      <div class="w-full md:w-64 border-b md:border-b-0 md:border-r border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900/50">
        <div class="flex flex-col p-2">
          <button 
            *ngFor="let tab of tabs; let i = index"
            (click)="selectTab(i)"
            class="flex items-center gap-3 px-4 py-3 rounded-lg text-left transition-all cursor-pointer"
            [ngClass]="{
              'bg-primary-50 dark:bg-primary-900/30 text-primary-600 dark:text-primary-400 font-medium': selectedTabIndex === i,
              'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800': selectedTabIndex !== i
            }">
            <mat-icon [svgIcon]="tab.icon"></mat-icon>
            <span class="flex-1">{{ tab.label }}</span>
            <span *ngIf="tab.badge" 
              class="px-2 py-0.5 text-xs rounded-full"
              [ngClass]="tab.badgeClass">
              {{ tab.badge }}
            </span>
          </button>
        </div>
      </div>

      <!-- Content Area -->
      <div class="flex-1 min-w-0 min-h-[500px]">
        
        <!-- 1. Dashboard -->
        <div *ngIf="selectedTabIndex === 0" class="tab-content">
          <app-ksef-dashboard></app-ksef-dashboard>
        </div>

        <!-- 2. Pending Batches -->
        <div *ngIf="selectedTabIndex === 1" class="tab-content">
          <app-pending-batches></app-pending-batches>
        </div>

        <!-- 3. Błędy Wysyłek -->
        <div *ngIf="selectedTabIndex === 2" class="tab-content">
          <app-errors-list></app-errors-list>
        </div>

        <!-- 4. Błędy Walidacji -->
        <div *ngIf="selectedTabIndex === 3" class="tab-content">
          <app-validation-errors-list></app-validation-errors-list>
        </div>

        <!-- 5. Historia Sesji Batch -->
        <div *ngIf="selectedTabIndex === 4" class="tab-content">
          <app-batch-sessions-list></app-batch-sessions-list>
        </div>

        <!-- 6. Synchronizacja -->
        <div *ngIf="selectedTabIndex === 5" class="tab-content">
          <app-sync-status></app-sync-status>
        </div>

        <!-- 7. Data Cleanup -->
        <div *ngIf="selectedTabIndex === 6" class="tab-content">
          <div class="p-6">
            <p class="text-secondary">Zarządzanie retencją logów (TODO)</p>
          </div>
        </div>

        <!-- 8. Narzędzia -->
        <div *ngIf="selectedTabIndex === 7" class="tab-content">
          <app-ksef-tools></app-ksef-tools>
        </div>

        <!-- 9. Weryfikacja NIP -->
        <div *ngIf="selectedTabIndex === 8" class="tab-content">
          <app-nip-verification></app-nip-verification>
        </div>

      </div>
    </div>
  </div>
  
</div>


